export { CommonFooter } from './CommonFooter';
